// @flow
/** @jsx isolateComponent */

import { isolateComponent, withModifier } from '@zapier/common-utils';

import type { Node } from 'react';

const Styles = {
  root: props => [
    {
      position: 'sticky',
    },

    withModifier('top', {
      top: props.top,
    }),

    /**
     * The styles below exist for legacy purposes, it reorganizes the sidebar
     * column so that the signup module appears at the top of the page on
     * smaller viewports. This code can be axed after we move to using the
     * design-system on the app profile pages.
     */
    {
      order: -999,
      '@media (min-width: 1000px)': {
        order: 'initial',
      },
    },
  ],
};

type Props = {
  children: Node,
  top: number,
};

const StickyNode = (props: Props) => (
  <div css={Styles.root(props)}>{props.children}</div>
);

StickyNode.defaultProps = {
  top: 20,
};

export default StickyNode;
